import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { systemCode, urls } from '..';
import { classIf } from '../data/utils/classIf';
import { getConfiguration } from '../data/utils/configuration';
import { iconSportCssClass } from '../data/utils/iconSportCssClass';
import LiveFavoritesButton from '../live/FavoritesButton';
import PrematchFavoritesButton from '../prematch/FavoritesButton';
import Badge from './Badge';
import { useIsDateSection } from './IsDateSectionProvider';
import { XRouterNavigateContext } from './seo/xrouter/XRouterNavigateContext';
import SportsDropdown from './SportsDropdown';
import useIsLiveSection from './useIsLiveSection';
import CalendarButton from '../live/calendar/CalendarButton';
import RouletteButtonScroller from './roulette/RouletteButtonScroller';
import { getItemsToRender } from '../utils/getItemsToRender';
import { removeMultipleSlashes } from '../data/sport-utils';
import StreamingAgendaButton from '../live/StreamingAgendaButton';
import { getLabel } from '../data/labels';
import RaceSportButtonScroller from './race-sport/RaceSportButtonScroller';
import HighlightedTournamentsButton from '../prematch/highlighted-tournaments/HighlightedTournamentsButton';
import SectionSwitcherButton from './SectionSwitcherButton';
import { getEnv } from '../data/env';

export default function SportScroller(props) {
    const xrouterNavigateContext = useContext(XRouterNavigateContext);
    const params = useParams();
    const pathname = useLocation().pathname;
    const isDateSection = useIsDateSection();
    const isLiveSection = useIsLiveSection();
    const [toggled, setToggled] = useState(false);

    function handleClick(e) {
        e.stopPropagation();
        setToggled(!toggled);
    }

    const scroller = useRef(null);
   

    useEffect(() => {
        const conf = getConfiguration();
        if (!conf.iwh && scroller.current) {
            scroller.current.querySelector('.xs_selected')?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
        const parent = scroller.current;
        const child = parent.querySelector('.xs_selected');
        if (conf.iwh && child) {
            const childOffset = child.offsetLeft + (child.offsetWidth / 2) - (parent.offsetWidth / 2);
            parent.scrollTo({ left: childOffset, behavior: 'instant' });
        }
    }, []);

    function getUrl(sport) {
        let url = null, replace = false;
        if (isLiveSection) {
            url = removeMultipleSlashes(`${urls.base}/${urls.live.base}/${sport.id}`);
        } else if (isDateSection) {
            if (pathname.startsWith(removeMultipleSlashes(`${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${urls.prematch.allMatches}`))) {
                url = removeMultipleSlashes(`${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${urls.prematch.allMatches}/${params.date}/${sport.id}/${sport.aggregata}`);
                replace = true;
            } else {
                url = removeMultipleSlashes(`${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${params.date}/${sport.id}/${sport.aggregata}`);
            }
        } else {
            url = removeMultipleSlashes(`${urls.base}/${urls.prematch.base}/${sport.id}`);
        }
        return [url, replace];
    }

    useEffect(() => {
        selectedSportRef?.current?.scrollIntoView(false);
    }, [])

    const selectedSportRef = useRef();
    const sportItems = props.sports.map(sport => {
        const sportIcon = iconSportCssClass(sport?.id, sport.iconClass);

        function handleClick() {
            if (props.changeSport) {
                props.changeSport(sport.id);
                return;
            }
            const [url, replace] = getUrl(sport);
            xrouterNavigateContext.navigate(url, { data: sport, replace });
        }

        const isSelected = props.selected?.id === sport.id;
        const conf = getConfiguration();

        return (
            <div ref={isSelected ? (conf.iwh ? null : selectedSportRef) : null} key={sport.id} className={"relative h-sports-navbar-height min-w-sports-navbar-height mx-1 shrink-0 flex flex-col items-center justify-center" + classIf(isSelected, 'xs_selected') + " icon-container-sport-" + sport.id} onClick={handleClick}>
                <div className="min-w-[60px] grid grid-cols-12 grid-rows-12 max-h-full leading-none items-center justify-items-center">
                    <div className={"xs-sport-icon col-start-1 col-end-13 row-start-1 row-end-10 inline-block h-[24px] w-[24px] " + sportIcon}></div>
                    <div className="col-start-1 col-end-13 row-start-10 row-end-13 font-bold text-xxs text-cs1 uppercase truncate">{sport.descrizione || sport.desc}</div>
                </div>
                {isLiveSection && sport.eventsCount > 0  &&
                    <Badge content={sport.eventsCount} />
                }
                {isSelected &&
                    <div className="absolute bottom-0 left-0 right-0 h-[4px] bg-cs4 rounded-xl"></div>
                }
            </div>
        );
    });
    const items = getItemsToRender(sportItems);
    const customer = getEnv('REACT_APP_XSPORT_CUSTOMER');
    const conf = getConfiguration();
    const showSwitcherButton = customer === 'totosi_xsportapp';

    return (
        <div className="xs_sportMenu grid grid-cols-12 items-center bg-cc1">
            <>
                {(props.showBackButton)  &&
                    <div className="col-start-1 col-end-2 flex items-center justify-center" onClick={() => xrouterNavigateContext.navigate(-1)}>
                        <i className="bi-arrow-left text-md text-cs1" />
                    </div>
                }
                <div className={`${props.showBackButton ? 'col-start-2' : 'col-start-1'} col-end-11 overflow-x-auto flex flex-none items-center`} ref={scroller}>
                    {!props.changeSport &&
                        <>
                            {isLiveSection ?
                                <LiveFavoritesButton />
                                :
                                <PrematchFavoritesButton />
                            }
                        </>
                    }
                    {systemCode === 'SUREBET' &&
                        <HighlightedTournamentsButton />
                    }
                    {(items?.length == 0 || !items?.find((item) => { return item?.typ?.includes('ROULETTE') })) &&
                        <RaceSportButtonScroller />
                    }

                    {items.map((item, i) =>
                        <React.Fragment key={i}>
                            {item?.typ?.includes('ROULETTE') ?
                                <>
                                    <RaceSportButtonScroller />
                                    <RouletteButtonScroller conf={item} />
                                </>
                                :
                                item
                            }
                        </React.Fragment>
                    )}
                    {props.showCalendar &&
                        <CalendarButton key={'calendar'} />
                    }
                    {props.showCalendar &&
                        <StreamingAgendaButton key={'agenda'} />
                    }
                </div>
            </>
            <div className="col-start-11 col-end-13" onClick={handleClick}>
                <div className="mx-1 shrink-0 flex flex-col items-center justify-center">
                    <i className={`text-lg text-cs1 bi-chevron-${toggled ? 'up' : 'down'}`}></i>
                    <div className="font-bold text-xxs text-cs1 uppercase truncate">{getLabel('general.other')}</div>
                </div>
            </div>
            {showSwitcherButton &&
                <SectionSwitcherButton />
            }
            {toggled &&
                <SportsDropdown sports={props.sports} selected={props.selected} toggle={handleClick} showCalendar={props.showCalendar} />
            }
        </div>
    );
}
